import { msg } from '@/shared/i18n/msg';
import type { TaskKind } from '../schemas/task-kind';
import type { TaskStatus } from '../schemas/task-status';

export const TASK_LABELS: {
  readonly kind: Readonly<Record<TaskKind, string>>;
  readonly status: Readonly<Record<TaskStatus, string>>;
} = {
  kind: { action: msg('Action'), recommendation: msg('Recommendation'), check: msg('Periodic check') },
  status: { todo: msg('Pending'), doing: msg('In progress'), done: msg('Done'), dismissed: msg('Dismissed') },
};
